import { Module } from '@nestjs/common';

import { AppController } from './app.controller';
import { AppService } from './app.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { AdjustmentNoteModule } from './adjustment-notes/adjustment-notes.module';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AdjustmentNotesEntity } from './adjustment-notes/entity/adjustment-note.entity';
import { ExpensesModule } from './expenses/expenses.module';
import { ExpensesEntity } from './expenses/expenses.entity';
import { ExpensesLogEntity } from './expenses/expensesLog.entity';
import { PurchaseProductsEntity } from './purchase-form/purchases-product.entity';
import { PurchasesEntity } from './purchase-form/purchases.entity';
import { PurchasesModule } from './purchase-form/purchase.module';
import { CollectionsEntity } from './collections/collections.entity';
import { CollectionsModule } from './collections/collections.module';
// import { ExpensesModule } from './expenses/expenses.module';

@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      // host: '142.93.219.119',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.finance_db,
      entities: [AdjustmentNotesEntity,ExpensesEntity,ExpensesLogEntity,PurchaseProductsEntity,PurchasesEntity,CollectionsEntity],
      synchronize: false,
      logging: true
    }),
    AdjustmentNoteModule,ExpensesModule,PurchasesModule,CollectionsModule
  ],
  controllers: [AppController],
  providers: [AppService,ApplicationExceptionHandler],
})
export class AppModule {}
